import type {SetPermissionOverrideFormPayload} from "./set-permission-override.schema";
import {setAccessAdministrationUserPermissionOverride} from "@project/sdk/access-administration";
import {SetAccessAdministrationUserPermissionOverrideResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {accessAdministrationMutationKeys, userAccessKeys} from "../../access-administration-keys";

export function setPermissionOverrideMutationOptions(userId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.setPermissionOverride,
    mutationFn: async ({
      permissionKey,
      payload,
    }: {
      permissionKey: string;
      payload: SetPermissionOverrideFormPayload;
    }) =>
      SetAccessAdministrationUserPermissionOverrideResponse.parse(
        await setAccessAdministrationUserPermissionOverride(userId, permissionKey, payload),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userAccessKeys.detail(userId)});
    },
  });
}
